import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";

import XeroIntegration from "./XeroIntegration";
import GoogleIntegration from "./GoogleIntegration";
import HmrcIntegration from "./HMRCIntegration";
import CompaniesHouseIntegration from "./CompaniesHouseIntegration";
import BrightPayIntegration from "./BrightPayIntegration";
import GpsLiveIntegration from "./GpsLiveIntegration";
import VapiIntegration from "./VapiIntegration";
import OutlookAddinIntegration from "./OutlookAddinIntegration";
import PhoneNumbers from "./PhoneNumbers";
import SettingsPanel from "../../components/SettingsPanel";

export default function ThirdPartyIntegrationSettings() {
  const params = useParams();
  const history = useHistory();

  const { activeTab: routeTab } = params;
  const [activeTab, setActiveTab] = useState(routeTab || "xero");

  useEffect(() => {
    // Sync tab selection to URL if user clicks tab
    if (routeTab !== activeTab) {
      const { mainTopTab, activeMenu, code } = params;
      history.replace(
        `/settings/${mainTopTab}/${activeMenu}/${activeTab}${
          code ? `/${code}` : ""
        }`
      );
    }
  }, [activeTab]);

  const Tabs = [
    {
      id: "xero",
      name: "Xero",
      Component: <XeroIntegration />,
    },
    {
      id: "google",
      name: "Google",
      Component: <GoogleIntegration />,
    },
    {
      id: "hmrc",
      name: "HMRC",
      Component: <HmrcIntegration />,
    },
    {
      // Change #100691 - accounts filing through the Companies House XML Gateway
      id: "companieshouse",
      name: "Companies House",
      Component: <CompaniesHouseIntegration />,
    },
    {
      id: "brightpay",
      name: "BrightPay",
      Component: <BrightPayIntegration />,
    },
    {
      id: "gpslive",
      name: "GPSLive",
      Component: <GpsLiveIntegration />,
    },
    {
      id: "vapi",
      name: "Virtual Receptionist",
      Component: <VapiIntegration />,
    },
    {
      id: "phone-numbers",
      name: "Phone Numbers",
      Component: <PhoneNumbers />,
    },
    {
      id: "outlook",
      name: "Outlook Add-in",
      Component: <OutlookAddinIntegration />,
    },
  ];

  return (
    <SettingsPanel
      title="3rd Party Integrations"
      description="Connect CRMit to Xero, Google, HMRC, Companies House, BrightPay and GPSLive for accounting, statutory filing, identity, payroll and vehicle tracking."
      tabs={Tabs.map((item) => ({ value: item.id, label: item.name }))}
      value={activeTab}
      onChange={setActiveTab}
    >
      <div className="integration-main-frame mt-2">
        {Tabs.find((item) => item.id === activeTab)?.Component}
      </div>
    </SettingsPanel>
  );
}
